module.exports = __webpack_public_path__ + "static/media/ST.f7e36001.svg";